@if (node$ | async; as node) {
  <kb-navigation-ui
    [node]="node"
    [flyout]="false"
    class="test"
    [ngClass]="(styleClass$ | async) ?? ''"
    [navAriaLabel]="'navigation.footerNavLabel' | cxTranslate"
  ></kb-navigation-ui>
}